import { Star } from "lucide-react";

export default function RatingDisplay({ avg, count, size = "sm" }) {
  if (!count) {
    return <span className="text-xs text-dapnow-muted">Nessuna valutazione</span>;
  }
  const px = size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5";
  return (
    <span className="inline-flex items-center gap-1 text-sm" data-testid="rating-display">
      <Star className={`${px} fill-yellow-400 text-yellow-400`} />
      <span className="font-semibold">{Number(avg).toFixed(1)}</span>
      <span className="text-dapnow-muted text-xs">({count})</span>
    </span>
  );
}
